export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/RightTick.cf1fad1e.svg","height":16,"width":16};